<template>
  <div class="dashboard-container">
    <div class="dashboard-text">{{ name }}</div>
    <div class="dashboard-text">欢迎进入 彩图奔跑 综合管理平台</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MonitorOverview',
  computed: {
    ...mapGetters([
      'name'
    ])
  },
  mounted() {
    this.test()
  },
  methods: {
    test() {
      // console.log('initData.store=', this.$store)
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard {
  &-container {
    margin: 30px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
</style>
